export const attachments = [
  { name: 'valuation', title: 'Most recent valuation/tax notice' },
  { name: 'personal', title: 'Personal Property Equipment List' },
  { name: 'other', title: 'Other documents as required' },
];
